'use client'

import { Activity, Zap, BarChart3, Globe } from 'lucide-react'

const features = [
  {
    icon: Activity,
    title: 'Signal Detection',
    description: 'Breakout scanner monitors hundreds of pairs in real time, surfacing high-probability setups with AI reasoning attached to every alert.',
  },
  {
    icon: Zap,
    title: 'Instant Execution',
    description: 'Execute directly from a signal in one click. Long, short, or close — routed to your Binance account with configurable size and leverage.',
  },
  {
    icon: BarChart3,
    title: 'Analytics Suite',
    description: 'Thirteen floating widgets — equity curve, drawdown, win rate, PnL distribution, exposure — dockable anywhere on any page.',
  },
  {
    icon: Globe,
    title: 'Market Intelligence',
    description: 'Live market movers, Binance Alpha listings, curated news feed, and crypto sparklines update continuously so you never miss a move.',
  },
]

export function FeaturesSection() {
  return (
    <section className="overflow-hidden py-16 md:py-32" style={{ fontFamily: 'var(--font-ppmori, PPMori), sans-serif' }}>
      <div className="mx-auto max-w-5xl space-y-8 px-6 md:space-y-16">

        <div className="relative z-10 max-w-2xl">
          <h2 className="text-4xl font-medium text-white lg:text-5xl">
            One workspace for the full trading loop.
          </h2>
          <p className="mt-6 text-lg text-white/50">
            From signal to execution to post-trade analysis — everything runs inside a single adaptive interface connected live to your exchange.
          </p>
        </div>

        {/* Dashboard screenshot — perspective tilt */}
        <div
          className="relative -mx-4 pr-3 pt-3 md:-mx-12"
          style={{
            maskImage: 'linear-gradient(to bottom, black 60%, transparent 100%), linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, black 60%, transparent 100%), linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
            maskComposite: 'intersect',
            WebkitMaskComposite: 'source-in',
          }}
        >
          <div style={{ perspective: '1200px' }}>
            <div style={{ transform: 'rotateX(6deg) skew(-2deg)', transformOrigin: 'top center' }}>
              <div className="relative overflow-hidden border border-white/10">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src="/previews/features-preview-1.webp"
                  alt="Algoglide features"
                  className="w-full object-cover object-top"
                  // style={{ imageRendering: 'high-quality' }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Feature cards */}
        <div className="grid grid-cols-2 gap-x-3 gap-y-8 sm:gap-8 lg:grid-cols-4">
          {features.map(({ icon: Icon, title, description }) => (
            <div key={title} className="space-y-3">
              <div className="flex items-center gap-2 text-white">
                <Icon className="size-4" />
                <h3 className="text-sm font-medium">{title}</h3>
              </div>
              <p className="text-sm text-white/40">{description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
